"use strict";
const {
  process_register_for_program,
  setSpecialtyBox,
} = require("./forms/process_register_for_program");

const submit_register = document.getElementById("save-the-date-register");
//hook on change event to specialty box
const specialtyContainer = document.querySelector("select[name='specialty'");

if (typeof specialtyContainer !== "undefined" && specialtyContainer !== null) {
  specialtyContainer.addEventListener("change", (e) => setSpecialtyBox(e));
}

if (typeof submit_register !== "undefined" && submit_register !== null) {
  submit_register.addEventListener("submit", (e) =>
    process_register_for_program(e)
  );
}
